import React, {useRef } from "react";
import "./App.css";
import Routes from "./Routes";
import logo from './img/logo.png';
import Container from "react-bootstrap/Container";
import Button from "react-bootstrap/Button";
import Footer from './components/Footer.js';
import { API } from "aws-amplify";
import { AppContext } from "./lib/contextLib";

function App() {
  const contactRef = useRef();

  async function getVersion() {
    let version = await API.get("gate", "/v").then(response => response).catch(error => null)
    return version
  }

  function handleMainLogoOnClick() {
    window.scrollTo({ top:0, left:0, behavior: "smooth"})
  }

  function handleFindInstallerOnClick() {
    contactRef.current.scrollIntoView({behavior: 'smooth'})
  }

  return (
    <div className="App">
      <Container fluid className="nav-bar">
        <Container className="inner">
          <div onClick={handleMainLogoOnClick} className="logomain"><img alt="Geedop Spatial" src={logo}/></div>
          <div className="nav-right">
            {/*<Button className="button sm outline menu" onClick={handleSideMenuShowOnClick}><img src={menuicon} alt=""/></Button>*/}
            <Button className="button sm rgt" variant="dark" onClick={handleFindInstallerOnClick}>Contact us</Button>
          </div>
          <div className="mob-nav-right">
            {/*<Button className="button sm outline menu" onClick={handleSideMenuShowOnClick}><img src={menuicon} alt=""/></Button>*/}
            <Button className="button sm rgt" variant="dark" onClick={handleFindInstallerOnClick}>Contact us</Button>
          </div>
        </Container>
      </Container>
       <AppContext.Provider value={{ getVersion }}>
        <Routes />
      </AppContext.Provider>
      <div className="footer" ref={contactRef} >
        <Footer />
      </div>
    </div>
  );
}

export default App;